import { HttpInterceptorFn } from '@angular/common/http';
import { inject, REQUEST_CONTEXT } from '@angular/core';
import { Request } from 'express';

import { APP_CONFIG } from '../app.config.token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  const context = inject(REQUEST_CONTEXT, { optional: true }) as {
    req: Request;
  } | null;
  const serverRequest = context?.req || null;
  const requestToYourApi = req.url.startsWith(config.apiUrl);

  if (!requestToYourApi) {
    return next(req);
  }

  // Base config for all environments
  let cloneOptions: {
    withCredentials: boolean;
    setHeaders?: Record<string, string | string[]>;
  } = {
    withCredentials: true,
  };

  // Add SSR specific headers if valid
  if (serverRequest) {
    const cookies = serverRequest.headers.cookie;
    if (cookies) {
      cloneOptions = {
        ...cloneOptions,
        setHeaders: {
          Cookie: cookies,
        },
      };
    }
  }

  const clonedRequest = req.clone(cloneOptions);
  return next(clonedRequest);
};
